import { DEVICE_STATUS } from '@/pages/Administration/Devices/Devices.constants';

import type { StatusColorType } from './DeviceStatusChip.types';

export default function getDeviceStatusColor(level: string): StatusColorType {
  switch (level) {
    case DEVICE_STATUS.DEVICE_ACTIVATED:
      return 'new';
    case DEVICE_STATUS.OPERATIONAL:
      return 'success';
    case DEVICE_STATUS.ERROR:
      return 'error';
    case DEVICE_STATUS.UNKNOWN:
      return 'unknown';
    case DEVICE_STATUS.DISABLED:
      return 'disabled';
    case DEVICE_STATUS.NEW:
      return 'new';
    case DEVICE_STATUS.DECOMMISSIONING:
      return 'warning';
    case DEVICE_STATUS.CATEGORY_FAILED:
      return 'warning';
    case DEVICE_STATUS.PENDING_RESTART:
      return 'warning';
    case DEVICE_STATUS.WARNING:
      return 'warning';
    case DEVICE_STATUS.CONFIG_SUCCESS:
      return 'success';
    case DEVICE_STATUS.CONFIG_FAILED:
      return 'error';
    case DEVICE_STATUS.DEPLOYMENT_FAILED:
      return 'error';
    case DEVICE_STATUS.JOB_FAILED:
      return 'error';
    default:
      return 'secondary';
  }
}
